/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TextField } from '@material-ui/core';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { TerminatedLabelerTableHead } from './TableHead';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import PaginationBox from '../../../../SharedModules/PaginationBox/PaginationBox';

import {
  quarterToDate,
  convertStringDate,
} from '../../../../SharedModules/utilities/dateUtilities';

const TerminatedLabelerDetail = (props) => {
  const dispatch = useDispatch();

  const {
    isLoading,
    detailObj: {
      rebateProgramValue,
      fromDateValue,
      searchResult,
      rebateProgramList,
      rebateProgrameName,
    },
  } = useSelector((state) => state?.sharedState?.TerminatedLabelerReducer);
  const rebateProgramNameValue = rebateProgrameName;

  const [rows, setRows] = React.useState([]);
  const [fullScreenView, setFullScreenView] = React.useState(false);

  // Function to toggle fullscreen view of table
  const changeFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  // Set the table data rows
  React.useEffect(() => {
    setRows(searchResult);
  }, [searchResult]);

  // Below 2 variable for PDF header slected information
  const thirdInfo = rebateProgramNameValue;
  const fourthInfo = `Quarter: ${fromDateValue}`;
  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />
      <CustomSeparator
        parent1="State Reports"
        parent2="Terminated Labeler Display"
      />

      <div className="tab-body">
        {!fullScreenView && (
          <>
            <div className="row">
              <div className="col-12  ">
                <div className="form-wrapper p-0 mt-2">
                  <div className="mui-custom-form input-md field-xl">
                    <div className="row mb-2">
                      <div className="col-6">
                        <TextField
                          label="Rebate Program: "
                          id="Rebate Program: "
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={rebateProgramNameValue}
                        />
                      </div>
                      <div className="col-6">
                        <TextField
                          label="Quarter: "
                          id="Quarter: "
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={fromDateValue}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        <div className="row" style={{ marginTop: 15 }}>
          <div className="unallocated" style={{ width: '100vw' }}>
            <TableGridWithFeatures
              gridHeight={viewPortHeight_355}
              columnDefs={TerminatedLabelerTableHead}
              rowData={rows}
              data-testid="onEditingStopped"
              enterMovesDown
              showResetFilter={false}
              hideTotalCount={false}
              exportFile
              reportName="Terminated state labeler Report"
              fileName="TerminatedLabelers"
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={changeFullScreenView}
              info={{ thirdInfo, fourthInfo }}
              // isScrollOn
              frameworkComponents={{
                TextBoxRender: (cellInfo) => {
                  const name = cellInfo?.value;

                  if (name && name.length > 35) {
                    return (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                      >
                        <div>{name}</div>
                      </OverlayTrigger>
                    );
                  }
                  return <div>{name}</div>;
                },
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TerminatedLabelerDetail;
